import { stopSend, type VideoSend } from '../uploads/video-sends.js';
import { length } from './video-format.js';

/** Why a video will not go, in as few words as say it. */
const REFUSED: Partial<Record<VideoSend['state'], string>> = {
  failed: "Didn't send",
};

/**
 * A video on its way: its thumbnail, the bar, and Stop; or, if it failed,
 * "Didn't send" and Remove. Shared by the athlete's and the coach's lists.
 */
export function SendingRow({ send }: { send: VideoSend }) {
  const share = send.state === 'done' ? 100 : send.totalBytes ? Math.round((send.sentBytes / send.totalBytes) * 100) : 0;
  const refused = REFUSED[send.state];
  return (
    <div className="video-row" data-state={send.state}>
      <span className="thumb" aria-hidden="true">
        {send.thumbnailUrl ? <img src={send.thumbnailUrl} alt="" /> : null}
        {send.durationSeconds ? <span className="dur">{length(send.durationSeconds)}</span> : null}
      </span>
      <div className="hour-row-text">
        {refused ? (
          <span className="detail refused">{refused}</span>
        ) : (
          <span
            className="send-bar"
            role="progressbar"
            aria-label="Sending"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={share}
            data-paused={send.paused ? '' : undefined}
          >
            <span style={{ width: `${share}%` }} />
          </span>
        )}
      </div>
      <div className="actions">
        <button type="button" onClick={() => stopSend(send.key)}>
          {refused ? 'Remove' : 'Stop'}
        </button>
      </div>
    </div>
  );
}
